module.exports = __webpack_public_path__ + "media/components/Cards/images/Gold-Elegant-Business-Card-2-78d6c72de2ee3851eafd28f6cc2631ca.png";